





























import {Vue, Component, Prop, Mixins} from "vue-property-decorator";
import {AxiosError, AxiosRequestConfig, AxiosResponse} from "axios";
import ErrorMessage from "@/components/messages/ErrorMessage.vue";
import Loading from "@/components/Loading.vue";


@Component({
    components: {Loading, ErrorMessage},
})
export default class BasicForm<S> extends Vue{

    @Prop({default:false}) displayCancelButton!:boolean;
    @Prop({default:'POST'}) method!:string;
    @Prop({}) action!:string;
    @Prop({default:"Submit"})
    submitButtonLabel!:string;
    cancelButtonLabel:string="Cancel";

    @Prop({})
    data!:S;

    error:AxiosError|null = null;

    config:AxiosRequestConfig = {
        headers:[]
    };

    onFly:boolean=false;

    mounted(){
        console.log("basic form mounted")
        if(this.action){
            this.config.url = this.action;
        }else {
            this.config.url = this.$route.path;
        }

        if(this.method){
            switch (this.method.toUpperCase()) {
                case "GET":
                    this.config.method = "GET";
                    break;
                case "POST":
                    this.config.method = "POST";
                    break;
                case "PUT":
                    this.config.method = "PUT";
                    break;
                case "DELETE":
                    this.config.method = "DELETE";
                    break;

                default:
                    break;
            }
        }else{
            this.config.method = "POST";
        }

        if(this.$attrs.submitButtonLabel){
            this.submitButtonLabel = this.$attrs.submitButtonLabel;
        }


    }

    reset(){
        this.error=null;
    }

    cancel(){
        this.$emit('cancel');
    }

    get buttonLabel(){
        return this.submitButtonLabel;
    }

    onSubmit(e:Event){
        e.preventDefault();

        this.onFly=true;

        if(window.localStorage.hasOwnProperty("token")){
            let token = localStorage.getItem("token");
            this.config.headers['Authorization'] = 'Bearer '+token;
        }else{
            delete this.config.headers['Authorization'];
        }

        this.config.data = this.data;
        //request<T = any, R = AxiosResponse<T>> (config: AxiosRequestConfig): Promise<R>;
        Vue.prototype.$http.request(this.config).then( (response:AxiosResponse)=>{
            this.$emit('success', response.data );
        }).catch( (error:AxiosError)=>{
            this.error = error;
        }).finally( ()=>{
            this.onFly=false;
        });
    }
}

